import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

const SEO = () => {
  const {
    i18n: { language },
  } = useTranslation();

  const { pathname } = useLocation();

  const enLdJsonProducts = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Product',
        name: 'Motor Insurance',
        brand: {
          '@type': 'Organization',
          name: 'Tameeni',
        },
        description:
          'Compare between 20+ insurance providers, select & buy the best motor insurance options that fit your needs. Insure your car online.',
        category: 'Motor Insurance',
        url: 'https://www.tameeni.com/en',
        aggregateRating: {
          '@type': 'AggregateRating',
          ratingValue: '4.7',
          reviewCount: '5826',
          bestRating: '5',
          worstRating: '1',
        },
      },
      {
        '@type': 'Product',
        name: 'Medical Malpractice Insurance',
        brand: {
          '@type': 'Organization',
          name: 'Tameeni',
        },
        description:
          'The best solutions for medical malpractice insurance in Saudi Arabia. Explore tailored coverage options to meet your needs.',
        category: 'Medical Malpractice Insurance',
        url: 'https://www.tameeni.com/en/mmp',
        aggregateRating: {
          '@type': 'AggregateRating',
          ratingValue: '4.7',
          reviewCount: '5826',
          bestRating: '5',
          worstRating: '1',
        },
      },
      {
        '@type': 'Product',
        name: 'SME Health Insurance',
        brand: {
          '@type': 'Organization',
          name: 'Tameeni',
        },
        description:
          'Within minutes, compare and get instant medical and health insurance for small and medium enterprises. Various benefits and many hospitals.',
        category: 'Health Insurance',
        url: 'https://www.tameeni.com/en/health-sme',
        aggregateRating: {
          '@type': 'AggregateRating',
          ratingValue: '4.7',
          reviewCount: '5826',
          bestRating: '5',
          worstRating: '1',
        },
      },
      {
        '@type': 'Product',
        name: 'Travel Insurance',
        brand: {
          '@type': 'Organization',
          name: 'Tameeni',
        },
        description:
          'Compare travel insurance plans from top providers and find the best coverage at competitive rates on Tameeni. Get quotes in seconds and travel with peace of mind.',
        category: 'Travel Insurance',
        url: 'https://www.tameeni.com/en/travel',
        aggregateRating: {
          '@type': 'AggregateRating',
          ratingValue: '4.7',
          reviewCount: '5826',
          bestRating: '5',
          worstRating: '1',
        },
      },
      {
        '@type': 'Product',
        name: 'Domestic Helper Insurance',
        brand: {
          '@type': 'Organization',
          name: 'Tameeni',
        },
        description:
          'Compare domestic helper insurance offers from leading companies in KSA and get the best prices to protect your helpers. Buy now.',
        category: 'Domestic Helper Insurance',
        url: 'https://www.tameeni.com/en/health',
        aggregateRating: {
          '@type': 'AggregateRating',
          ratingValue: '4.7',
          reviewCount: '5826',
          bestRating: '5',
          worstRating: '1',
        },
      },
    ],
  };

  const arLdJsonProducts = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Product',
        name: 'تأمين المركبات',
        brand: {
          '@type': 'Organization',
          name: 'تأميني',
        },
        description:
          'قارن بين أكثر من ٢٠ شركة تأمين من مكان واحد واحصل على خيارت تأمين  للسيارات في أقل من دقيقة ، أمن سيارتك الآن',
        category: 'تأمين المركبات',
        url: 'https://www.tameeni.com/ar',
        aggregateRating: {
          '@type': 'AggregateRating',
          ratingValue: '4.7',
          reviewCount: '5826',
          bestRating: '5',
          worstRating: '1',
        },
      },
      {
        '@type': 'Product',
        name: 'تأمين الأخطاء الطبية',
        brand: {
          '@type': 'Organization',
          name: 'تأميني',
        },
        description:
          'احصل على أفضل عروض التأمين لحماية الممارسين الطبيين والمؤسسات الصحية. اكتشف خيارات التغطية المخصصة لتلبية احتياجاتك. أمن الآن',
        category: 'تأمين ضد الأخطاء الطبية',
        url: 'https://www.tameeni.com/mmp',
        aggregateRating: {
          '@type': 'AggregateRating',
          ratingValue: '4.7',
          reviewCount: '5826',
          bestRating: '5',
          worstRating: '1',
        },
      },
      {
        '@type': 'Product',
        name: 'التأمين الصحي للمؤسسات الصغيرة والمتوسطة',
        brand: {
          '@type': 'Organization',
          name: 'تأميني',
        },
        description:
          'خلال دقائق قارن واحصل على وثيقة فورية للتأمين الطبي والصحي للمنشآت الصغيرة والمتوسطة لكثير من شركات التأمين المعتمدة في المملكة. منافع وشبكات مستشفيات متنوعة.',
        category: 'تأمين صحي',
        url: 'https://www.tameeni.com/ar/health-sme',
        aggregateRating: {
          '@type': 'AggregateRating',
          ratingValue: '4.7',
          reviewCount: '5826',
          bestRating: '5',
          worstRating: '1',
        },
      },
      {
        '@type': 'Product',
        name: 'تأمين العمالة المنزلية',
        brand: {
          '@type': 'Organization',
          name: 'تأميني',
        },
        description:
          'قارن بين عروض تأمين العمالة المنزلية في السعودية بسرعة وسهولة واحصل على الحماية المثالية بأفضل الاسعار. اشتر الآن.',
        category: 'تأمين العمالة المنزلية',
        url: 'https://www.tameeni.com/health',
        aggregateRating: {
          '@type': 'AggregateRating',
          ratingValue: '4.7',
          reviewCount: '5826',
          bestRating: '5',
          worstRating: '1',
        },
      },
      {
        '@type': 'Product',
        name: 'تأمين السفر',
        brand: {
          '@type': 'Organization',
          name: 'تأميني',
        },
        description:
          'قارن خطط التأمين على السفر من أفضل الشركات واحصل على تغطية شاملة بأسعار تنافسية مع تأميني. احصل على عروض الأسعار في ثوانٍ واستمتع برحلتك بطمأنينة.',
        category: 'تأمين سفر',
        url: 'https://www.tameeni.com/travel',
        aggregateRating: {
          '@type': 'AggregateRating',
          ratingValue: '4.7',
          reviewCount: '5826',
          bestRating: '5',
          worstRating: '1',
        },
      },
    ],
  };
  const arLdJsonPt1Of3 = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'تأميني',
    legalName: 'تأميني',
    url: 'https://www.tameeni.com',
    logo: 'https://www.tameeni.com/Resources/images/header-logo.svg',
    foundingDate: '2016',
    founders: [
      {
        '@type': 'Person',
        name: 'سليمان عبدالله الفلاج',
      },
      {
        '@type': 'Person',
        name: 'ثامر عبدالله الفلاج',
      },
    ],
    address: {
      '@type': 'PostalAddress',
      streetAddress: '7933 المهندس مساعد العنقري',
      addressLocality: 'السليمانية',
      addressRegion: 'RUH',
      postalCode: '12245',
      addressCountry: 'KSA',
    },
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'خدمة العملاء',
      telephone: '[8002444455]',
      email: 'support@tameeni.com',
    },
    sameAs: [
      'https://www.instagram.com/tameeniksa',
      'https://twitter.com/TameeniKSA',
      'https://www.snapchat.com/add/tameeniksa',
      'https://www.facebook.com/Tameeniksa/',
      'https://www.youtube.com/channel/UCRLnHZkwAWJW0UN5CvA6Xsg/',
      'https://www.linkedin.com/company/tameeniksa/',
    ],
  };
  const arLdJsonPt2Of3 = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: 'ما هو الفرق بين تأمين ضد الغير (طرف ثالث) والتأمين الشامل؟',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'يوفر تأمين ضد الغير (طرف ثالث) تغطية المسؤولية تجاه الغير فقط، وذلك حسب الشروط والاستثناءات الموضحة في وثيقة التأمين.علماً أن هذا التأمين يعد تأميناً إلزامياً حسب أنظمة المملكة العربية السعودية . التأمين الشامل : يوفر التأمين الشامل تغطية شاملة للمركبة المؤمن عليها وكذلك تغطية المسؤولية تجاه الغير. كما يشمل التأمين الشامل عادةً الخسارة أو الضرر للمركبة المؤمن عليها من الحوادث والحريق والسرقة، وذلك حسب الشروط والاستثناءات الموضحة في وثيقة التأمين',
        },
      },
      {
        '@type': 'Question',
        name: 'ماهي الوثيقة الموحدة للتأمين الإلزامي على المركبات؟',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'الوثيقة الموحدة للتأمين الإلزامي على المركبات هي وثيقة تحتوي على القواعد العامة والشروط للتأمين .والتي أصدرتها مؤسسة النقد العربي السعودي. ',
        },
      },
      {
        '@type': 'Question',
        name: 'هل موقع تأميني معتمد ومصرّح من الجهات الرسمية؟',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'نعم، موقع تأميني هو أول موقع إلكتروني لشراء وثائق التأمين تم ترخصيه من مؤسسة النقد العربي السعودي.',
        },
      },
    ],
  };
  const enLdJsonPt1Of3 = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Tameeni',
    legalName: 'Tameeni',
    url: 'https://www.tameeni.com/en',
    logo: 'https://www.tameeni.com/Resources/images/header-logo.svg',
    foundingDate: '2016',
    founders: [
      {
        '@type': 'Person',
        name: 'Suliman Alfallaj',
      },
      {
        '@type': 'Person',
        name: 'Thamer Alfallaj',
      },
    ],
    address: {
      '@type': 'PostalAddress',
      streetAddress: '7933 Al Muhandis Masaid Al Anqari',
      addressLocality: 'As Sulimaniyah',
      addressRegion: 'RUH',
      postalCode: '12245',
      addressCountry: 'KSA',
    },
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer care',
      telephone: '[8002444455]',
      email: 'support@tameeni.com',
    },
    sameAs: [
      'https://www.instagram.com/tameeniksa',
      'https://twitter.com/TameeniKSA',
      'https://www.snapchat.com/add/tameeniksa',
      'https://www.facebook.com/Tameeniksa/',
      'https://www.youtube.com/channel/UCRLnHZkwAWJW0UN5CvA6Xsg/',
      'https://www.linkedin.com/company/tameeniksa/',
    ],
  };
  const enLdJsonPt2Of3 = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: 'What is the unified policy for compulsory vehicle Insurance?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'The Unified Policy for Compulsory Vehicle Insurance is a document containing general rules and conditions for insurance issued by the Saudi Arabian Monetary Agency.',
        },
      },
      {
        '@type': 'Question',
        name: 'What is the difference between third party insurance and comprehensive insurance?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Third party (third party) insurance provides third party liability coverage only, as per the terms and conditions set out in the insurance policy. Note that this insurance is mandatory according to the regulations of the Kingdom of Saudi Arabia. Comprehensive insurance provides comprehensive coverage of the insured vehicle as well as third party liability coverage. Comprehensive insurance usually covers loss or damage to insured vehicle from accidents, fire and theft, as per the terms and exceptions set forth in the insurance policy.',
        },
      },
      {
        '@type': 'Question',
        name: 'What is the residence number?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'It is the number on the Resident ID card which consists of ten digits.',
        },
      },
    ],
  };
  const arLdJsonPt3Of3 = {
    '@context': 'https://schema.org/',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'الرئيسية',
        item: 'https://www.tameeni.com/',
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: 'تأمين مركبات',
        item: 'https://www.tameeni.com/',
      },
      {
        '@type': 'ListItem',
        position: 3,
        name: 'تأمين طبي للشركات الصغيرة والمتوسطة',
        item: 'https://health.tameeni.com/',
      },
      {
        '@type': 'ListItem',
        position: 4,
        name: 'تأمين العمالة المنزلية',
        item: 'https://dh.tameeni.com/',
      },
      {
        '@type': 'ListItem',
        position: 5,
        name: 'التأمين الأخطاء الطبية',
        item: 'https://mmp.tameeni.com/',
      },
      {
        '@type': 'ListItem',
        position: 6,
        name: 'تأمين السفر',
        item: 'https://travel.tameeni.com/',
      },
      {
        '@type': 'ListItem',
        position: 7,
        name: 'فحص تاريخ المركبة (موجز)',
        item: 'https://www.tameeni.com/car/ar/Vehicle-History-Check-Mojaz',
      },
      {
        '@type': 'ListItem',
        position: 8,
        name: 'الباقة الذكية',
        item: 'https://www.tameeni.com/car/ar/Smart-Package',
      },
    ],
  };
  const enLdJsonPt3Of3 = {
    '@context': 'https://schema.org/',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'Home',
        item: 'https://www.tameeni.com/en',
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: 'Motor Insurance',
        item: 'https://www.tameeni.com/en',
      },
      {
        '@type': 'ListItem',
        position: 3,
        name: 'SME Health Insurance',
        item: 'https://health.tameeni.com/en',
      },
      {
        '@type': 'ListItem',
        position: 4,
        name: 'Domestic Helper Insurance',
        item: 'https://dh.tameeni.com/en',
      },
      {
        '@type': 'ListItem',
        position: 5,
        name: 'Medical Malpractice Insurance',
        item: 'https://mmp.tameeni.com/en',
      },
      {
        '@type': 'ListItem',
        position: 6,
        name: 'Travel Insurance',
        item: 'https://travel.tameeni.com/en',
      },
      {
        '@type': 'ListItem',
        position: 7,
        name: 'Vehicle History - Mojaz',
        item: 'https://www.tameeni.com/car/en/Vehicle-History-Check-Mojaz',
      },
      {
        '@type': 'ListItem',
        position: 8,
        name: 'Smart Package',
        item: 'https://www.tameeni.com/car/en/Smart-Package',
      },
    ],
  };
  const arLdJsonPt4Of3 = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: 'ما هو التأمين الصحي للشركات الصغيرة؟',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'هو تأمين جماعي يغطي الموظفين ويوفر خدمات طبية ضمن شبكة معتمدة وفقًا لأنظمة الضمان الصحي.',
        },
        keywords: ['تأمين صحي', 'شركات صغيرة', 'تأمين جماعي', 'تغطية طبية'],
        category: 'التعريفات',
      },
      {
        '@type': 'Question',
        name: 'هل التأمين الصحي إلزامي على الشركات في السعودية؟',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'نعم، جميع المنشآت في السعودية ملزمة قانونًا بتوفير تأمين صحي لموظفيها وعائلاتهم حسب النظام.',
        },
        keywords: ['تأمين إلزامي', 'تأمين الموظفين', 'الضمان الصحي', 'التأمين في السعودية'],
        category: 'القوانين والأنظمة',
      },
      {
        '@type': 'Question',
        name: 'كم عدد الموظفين المطلوب لشراء تأمين جماعي؟',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'يمكن شراء تأمين جماعي حتى لشركة بعدد موظف واحد، حسب شروط مزود الخدمة.',
        },
        keywords: ['عدد الموظفين', 'شراء تأمين', 'شركات صغيرة', 'تأمين جماعي'],
        category: 'اشتراكات الشركات',
      },
      {
        '@type': 'Question',
        name: 'ما هي المستندات المطلوبة للحصول على التأمين؟',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'تشمل المستندات:رقم السجل التجاري، قائمة الموظفين،أرقام الهوية أو الإقامة، والإفصاحات الطبية.',
        },
        keywords: ['وثائق تأمين', 'اشتراك شركة', 'متطلبات التسجيل', 'سجل تجاري'],
        category: 'اشتراكات الشركات',
      },
      {
        '@type': 'Question',
        name: 'ما هي مميزات التأمين الصحي الجماعي؟',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'أسعار تنافسية، تغطيات شاملة، شبكة طبية أوسع، وإدارة مركزية للموظفين.',
        },
        keywords: ['مزايا التأمين', 'تأمين جماعي', 'فوائد التغطية'],
        category: 'المزايا',
      },
      {
        '@type': 'Question',
        name: 'هل يمكن تخصيص تغطيات مختلفة لفئات وظيفية؟',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'نعم، يمكن تخصيص باقات مختلفة حسب الفئة الوظيفية مثل الإدارية أو الفنية.',
        },
        keywords: ['تأمين متعدد الفئات', 'فئات التأمين', 'تغطية الموظفين'],
        category: 'إدارة الخطة',
      },
      {
        '@type': 'Question',
        name: 'ما هو الحد الأعلى للتغطية؟',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'يختلف حسب الباقة، ويتراوح غالبًا من 250,000 إلى 500,000 ريال سعودي سنويًا للفرد.',
        },
        keywords: ['حد التغطية', 'سقف المطالبات', 'باقة التأمين'],
        category: 'التغطية',
      },
      {
        '@type': 'Question',
        name: 'هل يمكن تغطية أفراد أسر الموظفين؟',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'نعم، يمكن تضمين الزوج/الزوجة والأبناء ضمن الوثيقة بناءً على سياسة الشركة.',
        },
        keywords: ['عائلة الموظف', 'التغطية العائلية', 'إضافة أفراد الأسرة'],
        category: 'التغطية',
      },
      {
        '@type': 'Question',
        name: 'هل يشمل التأمين الأمراض المزمنة؟',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'نعم، بشرط الإفصاح عنها عند التسجيل، وقد تُطبّق فترة انتظار أو حدود تغطية.',
        },
        keywords: ['أمراض مزمنة', 'تغطية شاملة', 'إفصاح طبي'],
        category: 'التغطية',
      },
      {
        '@type': 'Question',
        name: 'ما الفرق بين التأمين الفردي والجماعي؟',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'التأمين الجماعي يغطي الموظفين ضمن عقد واحد بأسعار مخفضة، بينما الفردي مستقل وأعلى تكلفة.',
        },
        keywords: ['مقارنة التأمين', 'الفردي مقابل الجماعي', 'أنواع التأمين'],
        category: 'التعريفات',
      },
      {
        '@type': 'Question',
        name: 'هل يمكن تقديم المطالبات إلكترونيًا؟',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'نعم، معظم مزودي التأمين يوفرون بوابات إلكترونية أو تطبيقات لتقديم المطالبات ومتابعتها.',
        },
        keywords: ['المطالبات', 'تقديم إلكتروني', 'مطالبة تأمين'],
        category: 'الخدمات الإلكترونية',
      },
      {
        '@type': 'Question',
        name: 'كم تستغرق معالجة المطالبة؟',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'تتراوح المدة بين 5 إلى 10 أيام عمل حسب نوع المطالبة والمستندات المرفقة.',
        },
        keywords: ['زمن المعالجة', 'مدة الرد', 'الرد على المطالبات'],
        category: 'الخدمات الإلكترونية',
      },
      {
        '@type': 'Question',
        name: 'هل يمكن تقسيط أقساط التأمين؟',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'نعم، بعض المزودين يوفرون خيارات تقسيط مرنة مثل الدفع الشهري أو نصف السنوي.',
        },
        keywords: ['تقسيط التأمين', 'طرق الدفع', 'خطة الدفع'],
        category: 'الدفع والاشتراك',
      },
      {
        '@type': 'Question',
        name: 'متى يبدأ التأمين للموظف الجديد؟',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'يُفضل تسجيل الموظف خلال 10 أيام من تاريخ تعيينه لضمان التغطية دون انقطاع.',
        },
        keywords: ['بدء التغطية', 'موظف جديد', 'تسجيل الموظفين'],
        category: 'الإدارة',
      },
      {
        '@type': 'Question',
        name: 'ماذا يحدث إذا غادر الموظف الشركة؟',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'يمكن إلغاء التغطية واسترداد جزء من القسط المدفوع، حسب سياسة شركة التأمين.',
        },
        keywords: ['إنهاء التأمين', 'خروج الموظف', 'استرجاع القسط'],
        category: 'الإدارة',
      },
      {
        '@type': 'Question',
        name: 'هل توجد غرامات عند عدم التأمين على الموظفين؟',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'نعم، قد تواجه المنشأة غرامات وتعليق خدمات حكومية في حال عدم الالتزام.',
        },
        keywords: ['غرامة التأمين', 'عدم التأمين', 'مخالفات الشركات'],
        category: 'القوانين والأنظمة',
      },
      {
        '@type': 'Question',
        name: 'هل يمكن تغيير مزود التأمين؟',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'نعم، عند انتهاء العقد السنوي أو حسب الشروط التعاقدية بين الطرفين.',
        },
        keywords: ['تغيير الشركة', 'مزود التأمين', 'نقل التأمين'],
        category: 'الإدارة',
      },
      {
        '@type': 'Question',
        name: 'كيف يتم تسعير التأمين؟',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'يُحدد السعر بناءً على عدد الموظفين، أعمارهم، نوع التغطية المطلوبة، والمنطقة الجغرافية.',
        },
        keywords: ['سعر التأمين', 'تسعير الشركات', 'عوامل التسعير'],
        category: 'الدفع والاشتراك',
      },
      {
        '@type': 'Question',
        name: 'هل هناك دعم باللغة الإنجليزية؟',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'نعم، معظم مقدمي التأمين يوفرون دعمًا ثنائي اللغة لخدمة جميع العملاء.',
        },
        keywords: ['اللغة الإنجليزية', 'دعم لغوي', 'خدمة العملاء'],
        category: 'الدعم',
      },
      {
        '@type': 'Question',
        name: 'هل يمكن ربط التأمين بنظام الموارد البشرية؟',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'نعم، بعض مزودي التأمين يقدمون تكامل تقني مع أنظمة إدارة الموارد البشرية.',
        },
        keywords: ['تكامل الموارد البشرية', 'ربط HR', 'API تأمين'],
        category: 'التكاملات',
      },
      {
        '@type': 'Question',
        name: 'هل توجد خطط تأمين للشركات الناشئة؟',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'نعم، بعض المزودين يقدمون خططًا مبسطة للشركات الصغيرة جدًا والناشئة بأسعار مرنة.',
        },
        keywords: ['شركات ناشئة', 'خطط مبسطة', 'تأمين شركات صغيرة'],
        category: 'الاشتراكات',
      },
      {
        '@type': 'Question',
        name: 'هل يمكن تعديل الخطة التأمينية خلال السنة؟',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'عادة لا، لكن بعض المزودين يتيحون التعديلات عند إضافة موظفين أو تغيير الفئات.',
        },
        keywords: ['تعديل الخطة', 'تغيير التغطية', 'تعديل التأمين'],
        category: 'الإدارة',
      },
      {
        '@type': 'Question',
        name: 'ما هي الفئات التي يمكن تغطيتها؟',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'يمكن تقسيم الموظفين إلى فئات مثل: تنفيذي، إداري، ميداني، وتحديد التغطية لكل فئة.',
        },
        keywords: ['فئات التأمين', 'تصنيف الموظفين', 'تخصيص التغطية'],
        category: 'التغطية',
      },
      {
        '@type': 'Question',
        name: 'هل هناك باقات تشمل العناية بالأسنان أو البصر؟',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'نعم، بعض الخطط تشمل تغطية إضافية مثل طب الأسنان أو العيون ضمن باقات مخصصة.',
        },
        keywords: ['طب الأسنان', 'البصر', 'تأمين إضافي'],
        category: 'التغطية',
      },
      {
        '@type': 'Question',
        name: 'هل يمكن متابعة حالة الموظف عبر لوحة تحكم؟',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'نعم، توفر بعض الشركات لوحات تحكم تُمكّنك من متابعة التغطية والمطالبات لكل موظف.',
        },
        keywords: ['لوحة تحكم', 'متابعة التغطية', 'إدارة التأمين'],
        category: 'الخدمات الإلكترونية',
      },
      {
        '@type': 'Question',
        name: 'ما دور مجلس الضمان الصحي؟',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'هو الجهة المنظمة والمراقبة لقطاع التأمين الصحي في السعودية، ويضع الأنظمة والسياسات.',
        },
        keywords: ['مجلس الضمان', 'تنظيم التأمين', 'التشريعات'],
        category: 'القوانين والأنظمة',
      },
      {
        '@type': 'Question',
        name: 'هل يجب تجديد التأمين سنويًا؟',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'نعم، وثائق التأمين تُبرم لمدة سنة واحدة ويجب تجديدها سنويًا لضمان الاستمرارية.',
        },
        keywords: ['تجديد سنوي', 'مدة التأمين', 'تحديث الوثيقة'],
        category: 'الإدارة',
      },
      {
        '@type': 'Question',
        name: 'هل يشمل التأمين جلسات العلاج الطبيعي؟',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'بعض الخطط تغطي العلاج الطبيعي بعد موافقة الطبيب المعالج، وتكون محدودة بعدد جلسات.',
        },
        keywords: ['العلاج الطبيعي', 'جلسات العلاج', 'تأهيل طبي'],
        category: 'التغطية',
      },
      {
        '@type': 'Question',
        name: 'هل أحتاج للتقديم بنفس المستندات عند كل تجديد؟',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'عادة لا، لكن تحديث بعض البيانات مثل عدد الموظفين أو الفئات مطلوب.',
        },
        keywords: ['تجديد الوثيقة', 'تحديث البيانات', 'المستندات'],
        category: 'الإدارة',
      },
      {
        '@type': 'Question',
        name: 'كيف أختار الخطة المناسبة لشركتي؟',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'قارن بين مستوى التغطية، تكلفة القسط، شبكة المستشفيات، ومدى توافق الخطة مع احتياجات الموظفين.',
        },
        keywords: ['اختيار التأمين', 'خطة التأمين', 'مقارنة الخطط'],
        category: 'الاشتراكات',
      },
    ],
  };

  return (
    <Helmet>
      <script type='application/ld+json'>
        {JSON.stringify(language === 'en' ? enLdJsonProducts : arLdJsonProducts)}
      </script>

      <script type='application/ld+json'>
        {JSON.stringify(language === 'en' ? enLdJsonPt1Of3 : arLdJsonPt1Of3)}
      </script>

      {/* Check the page pathname to show the correct schema Health SME vs Rest Products*/}
      {pathname.includes('/health-sme') ? (
        <script type='application/ld+json'>{JSON.stringify(arLdJsonPt4Of3)}</script>
      ) : (
        <script type='application/ld+json'>
          {JSON.stringify(language === 'en' ? enLdJsonPt2Of3 : arLdJsonPt2Of3)}
        </script>
      )}

      <script type='application/ld+json'>
        {JSON.stringify(language === 'en' ? enLdJsonPt3Of3 : arLdJsonPt3Of3)}
      </script>
    </Helmet>
  );
};

export default SEO;
